import { PaymentMethodCard } from '../cards/PaymentMethodCard';

export const PaymentMethodSection = () => {
    return (
        <section className="settings-section">
            <div className="settings-section-header">
                <div>
                    <h2 className="settings-section-title">Payment Method</h2>
                    <p className="settings-section-subtitle">Used for automatic renewals and add-on purchases</p>
                </div>
            </div>
            <div className="settings-section-body">
                <PaymentMethodCard />
            </div>
        </section>
    );
};
